// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import Portal from 'components/atoms/Portal';
import styles from './CollectOffSitesSearchModal.module.scss';
import { IconCloseTablet } from 'components/atoms/icons/IconCloseTablet';
import { useEffect, useState } from 'react';
import { CollectRouteSiteInfo } from 'types/routeManagementTypes';
import { getCollectRouteSites } from 'apis/collect_route';
import { useTranslation } from 'react-i18next';
import CollectRouteSelectStep from 'components/molecules/CollectRouteSelectStep';
import { InputDataListField } from 'components/molecules/InputDataListField';
import { Form } from 'react-final-form';
import { IconSearch } from 'components/atoms/icons/IconSearch';
import _debounce from 'lodash/debounce';
import { useSelector } from 'react-redux';
import { selectCollectingRouteSites } from 'redux/slices/collectingRoute';

type CollectOffSitesSearchModalProps = {
  onClose: () => void;
};

const CollectOffSitesSearchModal: React.FC<CollectOffSitesSearchModalProps> = ({
  onClose,
}) => {
  const [sites, setSites] = useState<CollectRouteSiteInfo[]>([]);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [keyword, setKeyword] = useState('');
  const { t } = useTranslation();
  const collectingRouteSites = useSelector(selectCollectingRouteSites);

  useEffect(() => {
    const debounceSetKeyword = _debounce(() => {
      setKeyword(searchInputValue);
    }, 500);

    debounceSetKeyword();

    return () => {
      debounceSetKeyword.cancel();
    };
  }, [searchInputValue]);

  useEffect(() => {
    getCollectRouteSites({
      routeId: 'none',
      keyword,
      successCallback: (data) => {
        setSites(
          data.sites.filter(
            (site) => !collectingRouteSites?.sites.some((s) => s.id === site.id)
          )
        );
      },
      failedCallback: () => {
        setSites([]);
      },
    });
  }, [keyword, collectingRouteSites]);

  const renderSitesList = () => {
    if (!sites.length) {
      return <div className={styles.empty}>{t('messages.M_008')}</div>;
    }

    return (
      <div className={styles.sitesList}>
        <CollectRouteSelectStep
          sites={sites}
          mode="all"
          onMemoUpdateSuccess={(siteId, note) => {
            setSites((prev) =>
              prev.map((site) =>
                site.id === siteId ? { ...site, hasMemo: Boolean(note) } : site
              )
            );
          }}
        />
      </div>
    );
  };

  return (
    <Portal>
      <Modal centered contentClassName={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {t('confirm_select_route_item.off_sites_search')}
          </h2>
          <IconCloseTablet onClick={onClose} />
        </div>

        <div className={styles.body}>
          <div className={styles.searchForm}>
            <Form onSubmit={() => {}}>
              {() => (
                <InputDataListField
                  name="search"
                  isDarkMode
                  placeholder={t('route_settings.search_site_placeholder')}
                  endExtraText={<IconSearch />}
                  className={styles.searchInput}
                  value={searchInputValue}
                  handleChange={setSearchInputValue}
                />
              )}
            </Form>
          </div>

          {renderSitesList()}
        </div>
      </Modal>
    </Portal>
  );
};

export default CollectOffSitesSearchModal;
